/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "जोड़ें"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "सभी को हटाएँ"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var hiIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { hiIN as h };
//# sourceMappingURL=hi-IN-DcfCtl8u.js.map
